import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TELEFON_ANLEGEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerTelefonAnlegenAdmin laden';
export const POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTelefonAnlegenAdmin ausführen';
export const POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTelefonAnlegenAdmin laden erfolgreich';
export const POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTelefonAnlegenAdmin Ladefehler';
export const POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTelefonAnlegenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTelefonAnlegenAdminAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ANLEGEN_ADMIN;
        constructor(public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAnlegenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAnlegenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAnlegenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefonRequest: api.BenutzerTelefonRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefonAnlegenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TELEFON_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTelefonAnlegenAdminActions =
    PostBenutzerTelefonAnlegenAdminAction
    | PostBenutzerTelefonAnlegenAdminAusfuehrenAction
    | PostBenutzerTelefonAnlegenAdminErfolgreichAction
    | PostBenutzerTelefonAnlegenAdminFehlerAction
    | PostBenutzerTelefonAnlegenAdminNichtAusgefuehrtAction
    ;
